import { notifications } from '@mantine/notifications';

export const showSuccessNotification = (title: string, message?: string) => {
  notifications.show({
    title,
    color: '#44B2B3',
    message,
    autoClose: 2000,
    position: 'top-right',
    styles: (theme) => ({
      root: {
        backgroundColor: theme.white,
      },
      closeButton: {
        '&:hover': {
          backgroundColor: theme.colors.green[7],
        },
      },
    }),
  });
};
